export const scheduleViewsTranslationsEn = {
  addScheduleViewCTA: 'Add quick view',
  createScheduleViewTitle: 'New quick view',
  defaultViewTooltip: 'Default',
  editScheduleViewPlaceholder: 'Name of the quick view',
  editScheduleViewsTitle: 'Edit quick views',
  editScheduleViewTitle: 'Edit quick view',
  iconAlreadyInUseTooltip: 'Icon is already in use',
  maxAmountReachedTooltip: 'The maximum number of quick views is 10',
  milestoneViewDisabledTooltip: 'Create a milestone to use the quick view',
  milestoneViewTooltip: 'Milestones',
  nameAlreadyInUseHint: 'This name is already in use',
  scheduleViewsTitle: 'Quick views',
  timeRange: 'Time Range',
};
